import React, { useEffect, useState } from 'react'

// Kendo functionality imports
import {
    Grid,
    // GridCellProps,
    GridColumn,
    GridFilterChangeEvent,
    // GridRowClickEvent,
    GridSortChangeEvent,
} from '@progress/kendo-react-grid'
import {
    CompositeFilterDescriptor,
    filterBy,
    orderBy,
    SortDescriptor,
} from '@progress/kendo-data-query'
import { formatDate } from '@telerik/kendo-intl'

import { Gateway } from './Interfaces'
import { DeleteGatewayCell } from './TableCells'
import useWindowDimensions from '../../GlobalComponents/GlobalFunctions'

export const KendoGridDateCell = (props: any) => {
    const value = props.dataItem[props.field]
    return <td>{value && formatDate(new Date(value), 'yyyy-MM-dd hh:mm:ss a')}</td>
}

export const GridData: React.FC<{
    data: Gateway[] | undefined
    loading: boolean
    error: any
    editRowClick: (event: any) => void
    deleteGateway: (gateway: Gateway) => void
}> = (props) => {
    // Window screen dimensions
    const { height } = useWindowDimensions()

    // Initial state for filter and sorting
    const initialFilter: CompositeFilterDescriptor = {
        logic: 'and',
        filters: [],
    }
    const initialSort: Array<SortDescriptor> = [{ field: 'Name', dir: 'asc' }]

    const [filter, setFilter] = React.useState(initialFilter)
    const [sort, setSort] = React.useState(initialSort)

    // Delete a specific gateway
    const DeleteGatewayCommandCell = (props: any) => (
        <DeleteGatewayCell {...props} deleteGateway={deleteGateway} />
    )

    // Delete certificate on row we click on
    const deleteGateway = (gateway: Gateway) => {
        props.deleteGateway(gateway)
    }

    if (props.loading) return <div>Loading data...</div>
    if (props.error) return <div>{props.error}</div>

    // Return data
    return (
        <div>
            {props.data && (
                <Grid
                    data={orderBy(filterBy(Object.values(props.data), filter), sort)}
                    filterable={true}
                    filter={filter}
                    onFilterChange={(e: GridFilterChangeEvent) => setFilter(e.filter)}
                    onRowClick={props.editRowClick}
                    onSortChange={(e: GridSortChangeEvent) => {
                        setSort(e.sort)
                    }}
                    scrollable="scrollable"
                    sortable={true}
                    sort={sort}
                    style={{ height: height - 105 }}
                >
                    <GridColumn field="Name" />
                    <GridColumn field="Username" />
                    <GridColumn field="URL" />
                    <GridColumn field="Protocol" />
                    <GridColumn
                        field="PartnerCertificateExpires"
                        cell={KendoGridDateCell}
                        title="Cert Expires"
                        filter="date"
                    />
                    <GridColumn
                        cell={DeleteGatewayCommandCell}
                        title="Delete"
                        width="75px"
                        filterable={false}
                        sortable={false}
                    />
                </Grid>
            )}
        </div>
    )
}
